// PrivacyPolicy.js
import React, { useEffect } from "react";
import "./PrivacyPolicy.css"; // You can create this CSS file for styling

const PrivacyPolicy = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="privacy-container">
      <h1>Privacy Policy</h1>
      <p>ˮNo mobile opt-in or text message consent
will be shared with third parties or affiliates
for marketing purposes.ˮ
</p>

      <p>
        <strong>Mindspace LLC</strong> (“Mindspace” or “us”) provides a platform for individuals to learn about depression and anxiety, understand treatment options, and connect with a Healthcare Provider for clinical care, if desired. Our Privacy Policy explains our information practices, the kinds of information we collect, how we use and share that information, and your options as it pertains to the sharing of your information.
      </p>

      <h2>Scope</h2>
      <p>
        This Privacy Policy applies to personal information processed by us during the course of business, including on our website (“Site”) and other online or offline offerings (collectively, the “Services”). Any individually identifiable information that is provided to us for purposes of rendering clinical services (also referred to as “Protected Health Information” or “PHI”) is subject to <strong>Mindspace’s Notice of Privacy Practices</strong>. The Notice of Privacy Practices describes how Mindspace can use and share your PHI and describes your rights with respect to this information.
      </p>

      <h2>Personal Information We Collect</h2>
      <h3>Account Creation</h3>
      <p>
        When you create a user account, we collect your name, e-mail, and password. All information collected and stored by us or which you provide when creating a Mindspace account is considered protected health information (“PHI”) and is governed by applicable state and federal laws, most notably HIPAA.
      </p>

      <h3>Communications with Us</h3>
      <p>
        We may collect personal information such as your email address, phone number, or mailing address when you request information about our Services, register for our newsletter, request support, or otherwise communicate with us.
      </p>

      <h2>Information Automatically Collected</h2>
      <p>
        We may collect information automatically when you use the Site or Services, including IP address, browser details, operating system, device information, location, and pages visited.
      </p>

      <h3>Cookies, Pixel Tags, and Analytics</h3>
      <p>
        We and third-party providers may use cookies, pixel tags, and analytics tools to automatically collect information for operational, performance, and advertising purposes.
      </p>

      <h2>How We Use Your Information</h2>
      <p>
        We use your information to manage accounts, respond to inquiries, provide access to Services, process transactions, analyze and improve the Site, prevent fraud, and comply with legal obligations.
      </p>

      <h2>Disclosure of Information</h2>
      
      <p>"Mobile Opt-in, SMS consent, and phone numbers collected for <strong>SMS communication purposes will not be shared with any third party or affiliates for marketing purposes</strong> "</p>

      <h2>International Data Transfers</h2>
      <p>
        Your information may be transferred, processed, and stored anywhere in the world, including countries with different data protection laws.
      </p>

      <h2>Your Choices</h2>
      <p>
        You may withdraw consent, manage email preferences, mobile settings, cookie preferences, and exercise your rights according to applicable law.
      </p>

      <h2>Your Privacy Rights</h2>
      <p>
        You may request confirmation of data processing, access or correction of data, deletion of data, or other rights depending on your state laws.
      </p>

      <h2>Data Retention</h2>
      <p>
        We retain personal information as long as necessary for the purposes described above, including legal compliance and business operations.
      </p>

      <h2>Security of Your Information</h2>
      <p>
        We take steps to secure your data, but cannot guarantee 100% security. We will notify you of breaches as required by law.
      </p>

      <h2>Children’s Information</h2>
      <p>
        Our Services are not intended for children under 18. We do not knowingly collect data from children. If you believe your child provided us with data, contact <strong>mindspace@mindspacellc.com</strong>.
      </p>

      <h2>Changes to This Privacy Policy</h2>
      <p>
        We may revise this Privacy Policy at our discretion. Continued use of Services after updates constitutes acceptance.
      </p>

      <h2>State-Specific Rights</h2>
      <p>
        Residents of California, Colorado, Connecticut, Utah, and Virginia have additional rights including requesting deletion or correction of personal data and opting out of sharing.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have questions or wish to exercise your rights, please contact us at: <br />
        <strong>Email:</strong> mindspace@mindspacellc.com <br />
        <strong>Mindspace LLC</strong> (Operating in Michigan and California)
      </p>
    </div>
  );
};

export default PrivacyPolicy;
